import { createUseStyles } from 'react-jss'
import { scrollableList } from '../../../../../../styles/common'

const useStyles = createUseStyles({
  list: {
    extend: scrollableList
  }
})

export default useStyles
